import { render } from "./SimpleModal.vue?vue&type=template&id=46734bfc"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"

import "./SimpleModal.vue?vue&type=style&index=0&id=46734bfc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__